import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
  static targets = ["input", "selectedList", "option"];

  connect() {
    this.updateSelectedOptions();
  }

  toggle(event) {
    const checkbox = event.currentTarget;
    const value = checkbox.value;
    const selectedValues = Array.from(this.inputTarget.selectedOptions).map(
      (option) => option.value
    );

    if (checkbox.checked) {
      if (!selectedValues.includes(value)) {
        this.selectOption(value);
      }
    } else {
      if (selectedValues.includes(value)) {
        this.deselectOption(value);
      }
    }

    this.updateSelectedOptions();
  }

  selectOption(value) {
    const option = this.inputTarget.querySelector(`option[value="${value}"]`);
    if (option) {
      option.selected = true;
    }
  }

  deselectOption(value) {
    const option = this.inputTarget.querySelector(`option[value="${value}"]`);
    if (option) {
      option.selected = false;
    }
  }

  updateSelectedOptions() {
    const selectedOptions = Array.from(this.inputTarget.selectedOptions);
    const selectedList = this.selectedListTarget;
    selectedList.innerHTML = "";

    selectedOptions.forEach((option) => {
      const tag = document.createElement("span");
      tag.className =
        "inline-flex items-center gap-1 px-2.5 py-1.5 rounded-sm text-sm font-medium bg-orange-100 text-orange-800";
      tag.innerHTML = `
        ${option.text}
        <button type="button" data-action="click->multi-select#removeTag" data-value="${option.value}" class="text-orange-600 hover:text-orange-900">
          <i class="fas fa-times"></i>
        </button>
      `;
      selectedList.appendChild(tag);
    });
  }

  removeTag(event) {
    event.preventDefault();
    const value = event.currentTarget.dataset.value;
    this.deselectOption(value);

    // Also uncheck the checkbox
    const checkbox = this.element.querySelector(`input[type="checkbox"][value="${value}"]`);
    if (checkbox) {
      checkbox.checked = false;
    }

    this.updateSelectedOptions();
  }
}
